import { render, staticRenderFns } from "./ResourceOverview.vue?vue&type=template&id=079b0254&"
import script from "./ResourceOverview.vue?vue&type=script&lang=js&"
export * from "./ResourceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports